import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, Select, Space, Table } from "antd";
import SearchArea from "../../components/moleculas/SearchArea";
import Styles from "./Styles";
import {
  apiGetDevice,
  apiGetServiceCode,
  apiGetSitesComp,
  apiGetZonesDrop,
  apiPutDeviceUpdate,
  apiGetEquipmentNotMapping,
} from "../../api/api";
import Moment from "react-moment";
import { getGlobalSessionParam, isEmpty, setGlobalSessionParam } from "../../utils/comm";
import SectionTitleArea from "../../components/moleculas/SectionTitleArea";

const { Option } = Select;
const { Column } = Table;

function ManageRegistDevice() {
  const [defaultValue] = useState({
    siteId: !isEmpty(getGlobalSessionParam("siteId")) ? getGlobalSessionParam("siteId") : null,
    svcCd: !isEmpty(getGlobalSessionParam("svcCd")) ? getGlobalSessionParam("svcCd") : null,
  });

  const StatusOptions = {
    SITE: "SITE",
    SERVICE: "SERVICE",
    SEARCH: "SEARCH",
  };
  const initStatus = useRef(
    new Map([
      [StatusOptions.SITE, false],
      [StatusOptions.SERVICE, false],
      [StatusOptions.SEARCH, false],
    ])
  );

  const [selectedCheckOption, setSelectedCheckOption] = useState(defaultValue.svcCd);
  const [formData, setFormData] = useState({ siteId: null });
  const [zoneData, setZoneData] = useState([]);
  const [equiData, setEquiData] = useState([{ devSn: "장비 없음", devId: 0 }]);
  const [deviceData, setDeviceData] = useState([]);
  const [sitesData, setSitesData] = useState([]);
  const [serviceData, setServiceData] = useState([]);
  let siteId = null;
  let serviceCd = [];
  let dataArray = [];

  useEffect(() => {
    apiGetSitesCompCall().then();
    if (!isEmpty(defaultValue.siteId)) {
      apiGetServiceCodeCall(defaultValue.siteId).then();
      siteId = defaultValue.siteId;
    } else {
      //apiGetZonesDropCall();
    }
  }, []);

  useEffect(() => {
    if (sitesData != null && sitesData.length > 0 && !initStatus.current.get(StatusOptions.SITE)) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SITE, true);

      let includeFlag = false;
      if (!isEmpty(defaultValue.siteId)) {
        sitesData.forEach((item) => {
          if (item.siteId === defaultValue.siteId) {
            includeFlag = true;
          }
        });
      }
      if (includeFlag) {
        setFormData({ ...formData, ["siteId"]: defaultValue.siteId });
      }
    }
  }, [sitesData]);

  useEffect(() => {
    if (serviceData != null && serviceData.length > 0 && !initStatus.current.get(StatusOptions.SERVICE)) {
      initStatus.current = new Map(initStatus.current).set(StatusOptions.SERVICE, true);
      setSelectedCheckOption(defaultValue.svcCd);
    }
  }, [serviceData]);

  useEffect(() => {
    apiGetZonesDropCall().then();
    apiGetEquiDropCall().then();
  }, [formData.siteId, selectedCheckOption]);

  // 사업장 드롭박스
  const apiGetSitesCompCall = async () => {
    const model = {
      compId: sessionStorage.getItem("compId"),
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetSitesComp(model);

      if (response.data.code === 0) {
        setSitesData([...response.data.data]);
      }
    } catch (e) {}
  };

  // 입력폼
  function changeSite(value) {
    siteId = value;
    setFormData({ ...formData, ["siteId"]: value });
    apiGetServiceCodeCall(null).then();
  }

  // 서비스 드롭박스
  const apiGetServiceCodeCall = async (sId) => {
    const model = {
      siteId: isEmpty(sId) ? siteId : sId,
      userId: sessionStorage.getItem("userId"),
    };

    try {
      const response = await apiGetServiceCode(model);

      setDeviceData([]);
      if (response.data.code === 0) {
        setServiceData(response.data.data);
      } else {
        setSelectedCheckOption([]);
      }
    } catch (e) {
      setSelectedCheckOption([]);
    }
  };

  // 구역 드롭박스
  const apiGetZonesDropCall = async () => {
    const model = {
      siteId: isEmpty(siteId) ? formData.siteId : siteId,
      svcCdList: selectedCheckOption,
    };

    try {
      const response = await apiGetZonesDrop(model);

      setDeviceData([]);
      if (response.data.code === 0) {
        setZoneData([...response.data.data]);
        apiGetDeviceCall().then();
      }
    } catch (e) {}
  };

  // 장비 드롭박스
  const apiGetEquiDropCall = async () => {
    const model = {
      siteId: isEmpty(siteId) ? formData.siteId : siteId,
      svcCdList: selectedCheckOption,
    };

    try {
      const response = await apiGetEquipmentNotMapping(model);
      setDeviceData([]);
      if (response.data.code === 0) {
        setEquiData([{ devSn: "장비 없음", devId: 0 }, ...response.data.data]);
        apiGetDeviceCall().then();
      }
    } catch (e) {}
  };

  // 디바이스 목록 조회
  const apiGetDeviceCall = async () => {
    const model = {
      siteId: isEmpty(siteId) ? formData.siteId : siteId,
      svcCdList: selectedCheckOption,
    };

    const modelParam = {
      siteId: isEmpty(siteId) ? formData.siteId : siteId,
      svcCd: selectedCheckOption,
    };

    try {
      const response = await apiGetDevice(model);

      setGlobalSessionParam(modelParam);

      if (response.data.code === 0) {
        setDeviceData([...response.data.data]);
      } else {
        setDeviceData([]);
      }
    } catch (e) {
      setDeviceData([]);
    }
  };

  // 디바이스 목록 저장
  const apiPutDeviceUpdateCall = async () => {
    const model = dataArray;
    if (isEmpty(model)) {
      return;
    }

    try {
      const response = await apiPutDeviceUpdate(model);
      if (response.data.code === 0 || response.data.code === 10) {
        Modal.confirm({
          title: "저장 완료",
          icon: null,
          content: "저장이 완료 되었습니다.",
          okText: "확인",
          centered: true,
          cancelButtonProps: { style: { display: "none" } },
        });

        apiGetDeviceCall().then();
      }
    } catch (e) {}
  };

  const setChangeData = (siteId, devId, zId, sNo, svcId, equId) => {
    if (isEmpty(sNo)) {
      return;
    }

    const setData = {
      siteId: siteId,
      devId: devId,
      znId: zId,
      serialNo: sNo,
      svcId: svcId,
      delYn: "N",
      equId: equId === null ? "0" : equId,
    };
    // 중복 데이터 모두 삭제
    dataArray = dataArray.filter((item) => item.serialNo !== sNo);
    // 신규데이터 등록
    dataArray.push(setData);
    //setNewDeviceDataSave(dataArray.concat(setData));

    // setDeviceDataSave(deviceDataSave.map((values) =>
    //   values.serialNo == sNo ? {...values,siteId:sessionStorage.getItem("siteId"),znId:zId,serialNo: sNo} : deviceDataSave
    // ));
  };

  const serviceHandleChange = (value) => {
    setSelectedCheckOption(value);
    // const lastValue = value[value.length-1];
    //
    // serviceCd.length = 0;
    // serviceCd.push('');
    // serviceData.map((values) =>
    //   serviceCd.push(values.catCd)
    // );
    //
    // if(!isAll) {
    //   //  all이 off > on 될 경우
    //   if(lastValue == '') {
    //     setSelectedCheckOption(serviceCd);
    //     setIsAll(true);
    //   } else {
    //     //  all을 제외한 것들이 on 될 경우
    //     setSelectedCheckOption(value);
    //   }
    // }
    //
    // // all 이 체크된 상태에서 무엇인가 체크해제 된다면
    // if(isAll) {
    //   // setSelectedCheckOption(value);
    //
    //   // 여전히 all이 체크 되어 있다(다른것이 해제 되었다면 all도 해제)
    //   if(value.includes('')) {
    //     const _value = value.filter((v) => {
    //       return v != '';
    //     })
    //     setSelectedCheckOption(_value);
    //   } else {
    //     // all이 체크해제 되었다면 모든요소 체크해제
    //     setSelectedCheckOption([]);
    //   }
    //   setIsAll(false);
    // }
  };

  return (
    <Styles className='has-table-resize'>
      <h1 className='page-tit'>디바이스 등록 관리</h1>
      <div className={"rpc-head-space rpc-pc"}>
        <SearchArea
          leftExtra={
            <Space size={[12, "small"]}>
              <div className='condition-item'>
                <label htmlFor='s1'>사업장</label>
                <Select
                  style={{ minWidth: 148 }}
                  id='s1'
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={formData.siteId}
                  onChange={(value) => changeSite(value)}
                >
                  {sitesData.map((values, index) => (
                    <Option key={index} value={values.siteId}>
                      {values.siteNm}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className='condition-item'>
                <label htmlFor='s2'>서비스</label>
                <Select
                  style={{ width: 230 }}
                  id='s2'
                  onChange={serviceHandleChange}
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={selectedCheckOption}
                >
                  {serviceData.map((values, index) => (
                    <Option key={index} value={values.catCd}>
                      {values.catNm}
                    </Option>
                  ))}
                </Select>
              </div>
            </Space>
          }
        />
        <SearchArea
          title='디바이스 목록'
          depth='depth2'
          rightExtra={
            <Button type='primary' onClick={apiPutDeviceUpdateCall}>
              저장
            </Button>
          }
        />
      </div>
      <div className={"rpc-head-space rpc-mobile"}>
        <SectionTitleArea title='디바이스 목록' depth='depth2' />
        <SearchArea
          leftExtra={
            <Space className={"rpc-head-container"} size={[12, "small"]}>
              <div className='condition-item'>
                <label htmlFor='s1'>사업장</label>
                <Select
                  style={{ minWidth: 148 }}
                  id='s1'
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={formData.siteId}
                  onChange={(value) => changeSite(value)}
                >
                  {sitesData.map((values, index) => (
                    <Option key={index} value={values.siteId}>
                      {values.siteNm}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className='rpc-head-item condition-item'>
                <label htmlFor='s2'>서비스</label>
                <Select
                  style={{ width: 230 }}
                  id='s2'
                  onChange={serviceHandleChange}
                  placeholder='선택'
                  allowClear
                  showArrow={true}
                  showSearch={false}
                  value={selectedCheckOption}
                >
                  {serviceData.map((values, index) => (
                    <Option key={index} value={values.catCd}>
                      {values.catNm}
                    </Option>
                  ))}
                </Select>
              </div>
            </Space>
          }
          rightExtra={
            <Button type='primary' style={{ width: "100%" }} onClick={apiPutDeviceUpdateCall}>
              저장
            </Button>
          }
        />
      </div>

      <div className='tbl-resize-wrapper' style={{ minHeight: 300 }}>
        <Table dataSource={deviceData} pagination={false} bordered showSorterTooltip={false} scroll={{ x: 600 }}>
          <Column title='No' dataIndex='no' key='1' width='50px' render={(value, record, index) => index + 1} />
          <Column title='서비스' dataIndex='catNm' key='2' />
          <Column title='시리얼 No' dataIndex='serialNo' key='3' />
          <Column title='디바이스 유형' dataIndex='codeNm' key='4' />
          <Column
            title='구역'
            dataIndex='znId'
            key='5'
            render={(value, record) => (
              <Select
                defaultValue={value}
                style={{ width: "100%" }}
                onChange={(value) =>
                  setChangeData(record.siteId, record.devId, value, record.serialNo, record.svcId, record.equId)
                }
              >
                {zoneData.map(
                  (values, index) =>
                    record.svcId === values.svcId && (
                      <Option key={index} value={values.znId}>
                        {values.znNm}
                      </Option>
                    )
                )}
              </Select>
            )}
          />
          <Column
            title='장비'
            dataIndex='equSn'
            key='6'
            render={(value, record) => (
              <Select
                defaultValue={value || 0}
                style={{ width: "100%" }}
                onChange={(value) =>
                  setChangeData(record.siteId, record.devId, record.znId, record.serialNo, record.svcId, value)
                }
              >
                {equiData.map((values, index) => (
                  <Option key={index} value={values.devId}>
                    {values.devSn}
                  </Option>
                ))}
              </Select>
            )}
          />
          <Column
            title='등록일'
            dataIndex='createDt'
            key='7'
            render={(value) => <Moment date={value} format={"YYYY-MM-DD"} />}
          />
        </Table>
      </div>
    </Styles>
  );
}

export default ManageRegistDevice;
